import { SetPrefixFieldData } from './ChartAxesInterfaces';

/**
 * This function sets the display name for a particular field.
 */
export const setDisplayName = (
  fieldData: SetPrefixFieldData,
  binName: string,
  chartType: string,
) => {
  if (!fieldData) {
    return fieldData;
  }
  let data = JSON.parse(JSON.stringify(fieldData));

  // basically the point is if its an aggregated calculated field
  if (data.isCalculatedField && data.isAggregated) {
    return data;
  }

  switch (data.dataType.toLowerCase()) {
    case 'integer':
    case 'decimal':
      if (['X', 'Y', 'X Axis', 'Y Axis', 'Measure'].includes(binName)) {
        data.displayname = `${data.agg} of ${data.fieldname}`;
      } else {
        data.displayname = data.fieldname;
      }
      break;

    case 'text':
      if (['X', 'Y', 'X Axis', 'Y Axis', 'Measure'].includes(binName)) {
        data.displayname = `${data.agg} of ${data.fieldname}`;
      } else {
        data.displayname = data.fieldname;
      }
      break;

    case 'date':
    case 'timestamp':
      // cause calendar chart works proper only with date
      if (chartType === 'calendar') {
        // if (binName === "Dimension") {
        if (binName === 'Date') {
          data.displayname = `${data.timeGrain} of ${data.fieldname}`;
        } else {
          data.displayname = `${data.agg} ${data.timeGrain} of ${data.fieldname}`;
        }
      } else {
        if (['X', 'Y', 'X Axis', 'Y Axis', 'Measure'].includes(binName)) {
          data.displayname = `${data.agg} ${data.timeGrain} of ${data.fieldname}`;
        } else if (binName === 'Dimension') {
          data.displayname = `${data.timeGrain} of ${data.fieldname}`;
        } else {
          data.displayname = `${data.timeGrain} of ${data.fieldname}`;
        }
      }
      break;

    default:
      break;
  }
  return data;
};
